import React from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate, useParams} from "react-router-dom";
import {FiPackage} from "react-icons/fi";
import {HiOutlineDocument} from "react-icons/hi";
import {TbDimensions, TbZoomMoney} from "react-icons/tb";
import {LiaCheckSolid} from "react-icons/lia";
import {PiMinusBold, PiPlusBold} from "react-icons/pi";
import {FaRegThumbsDown, FaRegThumbsUp} from "react-icons/fa";
import Footer from "../../Layouts/Footer";
import {LuTriangleAlert} from "react-icons/lu";

const Home = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [destination, setDestination] = React.useState([]);
    const [length, setLength] = React.useState([]);
    const [width, setWidth] = React.useState([]);
    const [height, setHeight] = React.useState([]);
    const [weight, setWeight] = React.useState([]);
    const [description, setDescription] = React.useState([]);
    const [isDocument, setIsDocument] = React.useState(0);
    const [needSign, setNeedSign] = React.useState(0);
    const [needInsurance, setNeedInsurance] = React.useState(0);
    const [checkDocument, setCheckDocument] = React.useState(0);
    const [parcelValue, setParcelValue] = React.useState(0);
    const [insurance, setInsurance] = React.useState(0);
    const [parcelCount, setParcelCount] = React.useState(1);

    const [loadContent, setLoadContent] = React.useState(1);
    const [showWeightTip, setShowWeightTip] = React.useState(false);
    const [redParcel, setRedParcel] = React.useState(false);
    const [priceData, setPriceData] = React.useState(null);
    const [content, setContent] = React.useState(null);

    React.useEffect(() => {

        API.getDestination(id)
            .then((response) => {
                setDestination(response.data);
                window.localStorage.setItem("did", response.data.id);
                setIsLoaded(true);
            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                }
            });


    }, [id]);

    React.useEffect(() => {
        let rows = [];
        for (let i = 0; i < parcelCount; i++) {
            let d = description;
            d[i] = Math.ceil((length[i] * width[i] * height[i]) / 139)
            setDescription(d)
            if (weight[i] < d[i]) {
                setShowWeightTip(true)
            }
            else {
                setShowWeightTip(false)
            }
            rows.push(<div className="col-12 mt-3 border-bottom pb-2 " key={i}>
                <div className="row ">
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Length"
                                   placeholder="Length"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       setPriceData(null)
                                       let l = length;
                                       l[i] = val.target.value
                                       setLength(l)

                                   }}
                            />
                            <label htmlFor="Length">Length (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Width"
                                   placeholder="Width"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       setPriceData(null)
                                       let w = width;
                                       w[i] = val.target.value
                                       setWidth(w)
                                   }}
                            />
                            <label htmlFor="Width">Width (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Height"
                                   placeholder="Height"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       setPriceData(null)
                                       let h = height;
                                       h[i] = val.target.value
                                       setHeight(h)
                                   }}
                            />
                            <label htmlFor="Height">Height (in):</label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="Weight"
                                   placeholder="Weight"
                                   onChange={(val) => {
                                       setLoadContent(loadContent + 1)
                                       setPriceData(null)
                                       let we = weight;
                                       we[i] = parseFloat(val.target.value)
                                       setWeight(we)
                                   }}
                            />
                            <label htmlFor="Weight">Weight (lb.):</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="Description"
                                   placeholder="Description"
                                   disabled={true}
                                   value={description[i]}
                                   onChange={(val) => {

                                       let d = description;
                                       d[i] = val.target.value
                                       setDescription(d)
                                   }}
                            />
                            <label htmlFor="Description">Dimensional weight (lb.):</label>

                        </div>
                    </div>

                </div>
            </div>)
        }
        setContent(rows);


    }, [parcelCount, loadContent]);

    const onGetQuote = () => {


        if (isDocument && !checkDocument) {
            toast.error('Please Confirm Envelopment Only Contains Document');
            return false
        }

        if (parcelValue < 1 && !isDocument) {
            toast.error('Please enter a valid number for parcel value');
            setRedParcel(true)
            return false
        }
        setRedParcel(false)
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },100)
        setIsLoaded(false);
        const request = {
            'id' : destination.id,
            weight,
            description,
            'parcel_value': parcelValue,
            'insurance': insurance,
            'is_document': isDocument,
            'need_signature': needSign
        }
        API.getQuote(request)
            .then((response) => {
                setPriceData(response.data);
                setCheckDocument(0)
                setIsLoaded(true);
                setTimeout (() => {
                    window.scrollTo({top: 1200, behavior: 'smooth'});
                },100)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);

                } else {
                    toast.error(error.message);

                }
            });
    }

     const onBook = () => {
         window.localStorage.setItem("did", destination.id);
         window.localStorage.setItem("dc", id);
         window.localStorage.setItem("_l", length);
         window.localStorage.setItem("_w", width);
         window.localStorage.setItem("_h", height);
         window.localStorage.setItem("_we", weight);
         window.localStorage.setItem("_de", description);
         window.localStorage.setItem("_id", isDocument);
         window.localStorage.setItem("_ns", needSign);
         window.localStorage.setItem("_c", parcelCount);
         window.localStorage.setItem("_pr", priceData.price);
         window.localStorage.setItem("_pv", parcelValue);
         window.localStorage.setItem("_in", insurance);
         navigate('/')
     }


    return (
        <React.Fragment>
            <Header/>

            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className='container mt-5 pt-5 '>
                <div className="row ">
                    <div className="col-md-7 pt-3 mt-2 ">
                        <p dangerouslySetInnerHTML={{__html: destination?.about}} className='px-5' ></p>
                    </div>
                    <div className="col-md-5 ">
                    <img src={destination?.cover_image} alt={destination?.title} className='w-100'/>
                    </div>

                </div>
            </section>
            <section className="container mt-2 ">
                <div className="row">
                    <div className="col-12 mb-3">
                        <h3 className='fw-bold'>
                            Get Quick <span className='text-warning'>Quote</span>:
                        </h3>
                    </div>
                    <div className="col-12 my-3">
                        <div className="row">

                            <div
                                className='col-md-3 col-6'
                            >
                                <div
                                     className={isDocument === 1 ? " not-active" : " is-active"}
                                     role='button'
                                     onClick={() => {
                                         setPriceData(null)
                                         setIsDocument(0)
                                     }}>
                                    {isDocument !== 1 &&
                                        <LiaCheckSolid className='float-start'/>
                                    }
                                    <FiPackage className='mx-2 text-big-3'/>
                                    Package
                                </div>

                            </div>
                            <div
                                className='col-md-3 col-6'
                            >
                                <div
                                className={isDocument === 1 ? " is-active doc-but" : " not-active doc-but"}
                                role='button'
                                onClick={() => {
                                setPriceData(null)
                                setIsDocument(1)
                            }}>
                                    {isDocument === 1 &&
                                        <LiaCheckSolid className='float-start'/>
                                    }
                                    <HiOutlineDocument className='mx-2 text-big-3'/>
                                    Document
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card text-center border-0   ">

                        <div className="card-body not-active  p-md-4">
                            <div className="row  pb-3 my-4 ">


                                {!isDocument &&
                                    <div className="row mt-3">

                                        <div className="col-12">
                                            <h5 className='text-start'>
                                                <TbDimensions className='mx-2 text-big-3 '/>
                                                <strong className='mt-5'>
                                                    Dimensions and Weight
                                                </strong>
                                            </h5>
                                        </div>

                                        <div className='px-md-3'>
                                            <div className='bg-white p-4 rounded '>
                                                {
                                                    content
                                                }
                                            </div>
                                        </div>


                                        <div className="col-12 text-start">
                                            <button className='is-active px-4 mt-3 text-small-3'
                                                    style={{borderStyle: 'solid'}}

                                                    onClick={() => {
                                                        setParcelCount(parcelCount + 1)
                                                    }}
                                            >
                                                <PiPlusBold className='mx-2 text-big-2'/>
                                                Add Item Row
                                            </button>
                                            <button className='not-active px-md-4 mx-md-3 mt-3 text-small-3'


                                                    onClick={() => {
                                                        if (parcelCount > 0) {
                                                            let w = weight;
                                                            w[parcelCount - 1] = 0;
                                                            setWeight(w)
                                                            let d = description;
                                                            d[parcelCount - 1] = 0;
                                                            setDescription(d)
                                                            setParcelCount(parcelCount - 1)
                                                        }
                                                    }}
                                            >
                                                <PiMinusBold className='mx-2 text-big-2'/>
                                                Remove Last Item
                                            </button>
                                        </div>


                                    </div>
                                }
                                <div className="row  pb-3 my-4 px-md-5 pt-4">
                                    {
                                        !isDocument &&
                                        <React.Fragment>
                                            <div className="col-md-6  text-start fw-bold my-3">
                                                Parcel Value:
                                            </div>
                                            <div className="col-md-6 my-md-3">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className="form-control" id="floatingInput"
                                                           style={{border: redParcel ? '2px solid red' : 'none'}}
                                                           placeholder="parcel"
                                                           required={true}
                                                           value={parcelValue}
                                                           onChange={(val) => {
                                                               val.target.value > 0 ? setRedParcel(false) : setRedParcel(true)
                                                               setParcelValue(val.target.value)
                                                               setPriceData(null)
                                                           }}
                                                    />
                                                    <label htmlFor="floatingInput">Value (CAD)</label>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    }
                                    <div className="col-md-6 fw-bold text-capitalize p-2 text-start">
                                        Is recipient signature required?
                                    </div>
                                    <div
                                        style={{borderStyle: 'solid'}}
                                        className={needSign === 0 ? " col-3 text-center p-2 bg-white border-0 mobile-s-20" : "col-3 text-center p-2 bg-white is-active rounded fw-bold mobile-s-20"}
                                        role='button'
                                        onClick={() => {
                                            setPriceData(null)
                                            setNeedSign(1)
                                        }}
                                    >

                                        <FaRegThumbsUp className='mx-2 text-big-3'/>
                                        Yes
                                    </div>
                                    <div
                                        style={{borderStyle: 'solid'}}
                                        className={needSign === 0 ? "col-3 text-center p-2 bg-white is-active fw-bold rounded" : "col-3 text-center p-2 bg-white border-0"}
                                        role='button'
                                        onClick={() => {
                                            setPriceData(null)
                                            setNeedSign(0)
                                        }}
                                    >

                                        <FaRegThumbsDown className='mx-2 text-big-3'/>
                                        No
                                    </div>


                                    {
                                        !isDocument &&
                                        <React.Fragment>
                                            <div className="col-md-6 fw-bold text-capitalize p-2 text-start mt-4">
                                                Do You Need Additional Insurance?
                                            </div>
                                            <div
                                                style={{borderStyle: 'solid'}}
                                                className={needInsurance === 0 ? "mobile-s-20 col-3 text-center p-2 bg-white mt-4 border-0" : " mobile-s-20 col-3 text-center p-2 bg-white is-active rounded fw-bold  mt-4"}
                                                role='button'
                                                onClick={() => {
                                                    setPriceData(null)
                                                    setNeedInsurance(1)
                                                }}
                                            >

                                                <FaRegThumbsUp className='mx-2 text-big-3'/>
                                                Yes
                                            </div>
                                            <div
                                                style={{borderStyle: 'solid'}}
                                                className={needInsurance === 0 ? " col-3 mt-4 text-center p-2 bg-white is-active fw-bold rounded" : "  col-3 text-center p-2 bg-white border-0 mt-4"}
                                                role='button'
                                                onClick={() => {
                                                    setPriceData(null)
                                                    setNeedInsurance(0)
                                                    setInsurance(0)
                                                }}
                                            >

                                                <FaRegThumbsDown className='mx-2 text-big-3'/>
                                                No
                                            </div>
                                        </React.Fragment>
                                    }
                                    {
                                        needInsurance > 0 &&
                                        <React.Fragment>
                                            <div className="col-md-6  text-start fw-bold my-4">
                                                Enter value Of the goods being shipped :


                                            </div>
                                            <div className="col-md-6 my-md-3">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className="form-control" id="floatingInput"
                                                           placeholder="parcel"
                                                           value={insurance}
                                                           onChange={(val) => {
                                                               setInsurance(val.target.value)
                                                               setPriceData(null)
                                                           }}
                                                    />
                                                    <label htmlFor="floatingInput">Value (CAD)</label>
                                                </div>
                                                <div className="alert alert-info mt-4 text-small-1 fw-bold ">
                                                    Your parcel is automatically insured for up to $100 by default,
                                                    without purchasing any additional coverage.
                                                </div>
                                            </div>

                                            <div className='text-start text-muted'>
                                                Insurance Note:
                                                <br/>
                                                By Entering Insurance Value , You acknowledge that You have read and
                                                accepted the  &nbsp;
                                                <a href="https://cheapship.ca/storage/app/media/terms/Insurance-Rev.02.pdf"
                                                   rel='noreferrer' target='_blank'>Cheapship Insurance Terms</a>
                                                . For a list of products that cannot be insured please
                                                &nbsp;
                                                <a href="https://cheapship.ca/storage/app/media/terms/cid.pdf"
                                                   rel='noreferrer' target='_blank'>click here</a>
                                                . You also acknowledge that if an accurate description of goods has not
                                                been provided, any insurance on the shipment will be void.
                                            </div>

                                        </React.Fragment>
                                    }
                                </div>

                                    {showWeightTip && priceData && !isDocument && id === 'IR' &&
                                        <div className="col-12">
                                            <div
                                                className="alert alert-info mt-4 text-small-2 fw-bold persian text-justify rtl">
                                                <LuTriangleAlert className='mx-2 text-big-3' />
                                                توجه: وزن حجمی بسته شما بیشتر از وزن واقعی آن است.
                                                اگر میخواهید که هزینه ارسال شما مقرون‌به‌صرفه‌تر باشد،
                                                میتوانید یا اندازه جعبه را کوچک‌تر کنید تا وزن حجمی به وزن
                                                واقعی نزدیک‌تر شود، یا بدون پرداخت هزینه اضافی،
                                                میتوانیدکالاهای بیشتری داخل جعبه قرار دهید تا وزن واقعی به
                                                وزن حجمی برسد .
                                            </div>
                                        </div>
                                    }

                            </div>
                            <div className="card-footer text-muted bg-warning-subtle">
                                {
                                    priceData ?
                                        <div className='row'>

                                            <div className="col-md-8 ">
                                                <div
                                                    className="row mt-3 border-bottom pb-1 border-secondary text-nowrap mobile-table-head">
                                                    <div className="col-3  ">
                                                        Services
                                                    </div>
                                                    <div className="col-3  ">
                                                        Est. Transit
                                                    </div>
                                                    <div className="col-2  ">
                                                        Shipping fee
                                                    </div>
                                                    <div className="col-2  ">
                                                        GST/HST
                                                    </div>
                                                    <div className="col-2  ">
                                                    Total
                                                    </div>

                                                </div>
                                                <div className="row mt-3 mb-5 mobile-table-text">
                                                    <div className="col-3  ">
                                                       Air Freight
                                                    </div>
                                                    <div className="col-3  ">
                                                        {destination.duration}
                                                    </div>
                                                    <div className="col-2  ">
                                                        ${priceData.price} CAD
                                                    </div>
                                                    <div className="col-2  ">
                                                        $0.00
                                                    </div>
                                                    <div className="col-2  fw-bold text-theme ">
                                                        ${priceData.price} CAD
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-4 my-3">
                                            <button className="btn btn-primary  text-capitalize w-100 mt-4"
                                                        onClick={() => {
                                                            onBook()
                                                        }}
                                                >

                                                    Book Shipment

                                                </button>
                                            </div>
                                            <div className="col-md-12 text-start">
                                                <p dangerouslySetInnerHTML={{__html: destination.description}}></p>
                                            </div>



                                        </div> :
                                        <React.Fragment>
                                            {
                                                isDocument > 0 &&
                                                <div className="form-check text-start my-3">
                                                    <input className="form-check-input" type="checkbox"
                                                           value={checkDocument}
                                                           onChange={() => {
                                                               setCheckDocument(1 - checkDocument)
                                                           }}
                                                           id="flexCheckDefault"/>
                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                        I Confirm This Envelopment Only Contains Document
                                                    </label>
                                                    <p className='text-muted text-small-2'>
                                                        Please note that this service only allows for the shipment of one envelope at a time, and does not accept specific types of documents such as passport, identity card, credit card and currency.
                                                    </p>
                                                </div>
                                            }

                                            <button className="btn btn-primary w-50"
                                                    onClick={() => {
                                                        onGetQuote()
                                                    }}
                                            >
                                                <TbZoomMoney className='mx-2 text-big-3'/>
                                                Calculate Shipment Price
                                            </button>
                                        </React.Fragment>

                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className="container-fluid mt-5 pt-5 gray-design-bg">
                <div className="container py-5">
                    <div className="row mx-3">
                        <div className="col-md-7 ">
                            <p dangerouslySetInnerHTML={{__html: destination?.description1}}></p>
                        </div>
                        <div className="col-md-5">
                            <img src={destination?.photo1} alt={destination?.title} className='w-100'/>
                        </div>
                    </div>
                </div>

            </section>
            <section className="container mt-5 pt-5">
                <div className="row mx-3 mt-5 ">
                    <div className="col-md-5">
                        <img src={destination?.photo2} alt={destination?.title} className='w-100'/>
                    </div>
                    <div className="col-md-7 ">
                        <p dangerouslySetInnerHTML={{__html: destination?.description2}}></p>
                    </div>

                </div>
            </section>
<Footer/>
        </React.Fragment>
    );
};

export default Home;